export default __webpack_public_path__ + "static/media/OriginBit_black.2e04d64a.png";